import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
      if (route.routeConfig?.path === 'login') {
        this.router.navigate(['/']);
        return false;
      }
      return true;
    } else if (route.routeConfig?.path !== 'login') {
      this.router.navigate(['/login']);
      return false;
    }
    return true;
  }
}
